import { useState, useMemo } from 'react';
import { TenderActivity } from '~/services/tenders/activity';
import { Dialog, DialogTrigger, DialogContent } from '@/components/ui/dialog';
import ParticipantsActivityList from 'Components/ParticipantsActivityList';
import ActivityIconButton from 'Components/ActivityIconButton';
import { useOrderActivity } from '~/hooks/useOrderActivity';

interface OrderActivityProps {
  orderId: string;
  activity: Record<string, string | null>;
  participants: Record<string, string>;
}

export default function OrderActivity({
  orderId,
  activity,
  participants,
}: OrderActivityProps) {
  const [open, setOpen] = useState(false);

  const staticUsers = useMemo(
    () =>
      Object.entries(activity).map(
        ([id, lastSeen]) =>
          new TenderActivity({
            id,
            name: participants[id] || id,
            last_seen: lastSeen,
          })
      ),
    [activity, participants]
  );

  const { data: freshUsers } = useOrderActivity(orderId, open);

  const num = staticUsers.filter((u) => u.status === 'active').length;
  const hasViews = staticUsers.some((u) => u.status !== 'inactive');
  const dialogUsers = freshUsers ?? staticUsers;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <ActivityIconButton
          num={num}
          hasViews={hasViews}
          onClick={(e) => e.stopPropagation()}
        />
      </DialogTrigger>
      <DialogContent
        className="tw:w-auto tw:min-w-sm tw:max-w-md"
        onClick={(e) => e.stopPropagation()}
      >
        <ParticipantsActivityList users={dialogUsers} />
      </DialogContent>
    </Dialog>
  );
}
